import { Stack } from "@similarweb/ui-components/foundations";

import { StyledFiltersList } from "app/pages/sales-intelligence/common-components/filters-panel/components/FiltersList/styles";
import FiltersListLoader from "app/pages/sales-intelligence/common-components/filters-panel/components/FiltersListLoader/FiltersListLoader";
import { useScrollbarType } from "app/pages/sales-intelligence/hooks/useScrollbarType";
import type { IPlainObject } from "app/pages/sales-intelligence/types/plainObject";

import type { FilterInstanceType } from "../../types/filterInstance";
import { FilterPanelItem } from "../FilterPanelItem/FilterPanelItem";

import type { FiltersListProps } from "./types";

export const FiltersList = <T extends IPlainObject = IPlainObject>({
    isLoading = false,
    filtersManager,
    expandedFilter,
    renderActions,
    onToggleExpand,
    onFilterUpdate,
    onClearFilter,
}: FiltersListProps<T>) => {
    const scrollbarType = useScrollbarType();

    return (
        <StyledFiltersList $hasOverlayScrollbar={scrollbarType === "overlay"}>
            {isLoading ? (
                <FiltersListLoader rowNumber={6} />
            ) : (
                <Stack
                    data-automation="filter-panel.items-wrapper"
                    gap="8px"
                >
                    {filtersManager.getAll().map((config: FilterInstanceType<T, unknown, unknown>) => (
                        <FilterPanelItem<T>
                            key={String(config.key)}
                            isExpanded={expandedFilter === config.key}
                            filterConfig={config}
                            filterDtoValue={filtersManager.getFilterDtoValue(config.key)}
                            onFilterUpdate={onFilterUpdate}
                            renderActions={renderActions}
                            onToggleExpand={onToggleExpand}
                            isShowClearButton={filtersManager.isFilterDirty(config.key)}
                            isDisabled={filtersManager.isFilterDisabled(config.key)}
                            onClear={onClearFilter}
                        />
                    ))}
                </Stack>
            )}
        </StyledFiltersList>
    );
};
